
import { Component, Vue, Watch } from 'vue-property-decorator'
import ProductProvider from '@/resources/product.provider'

const NoPicture = require('@/assets/no_picture_available.png')

const ProductService = new ProductProvider()

@Component
export default class UpdateProductWeightAndDimension extends Vue {
  product: any = null

  $convertImgix: any

  saving = false

  getting = true

  query: any = {
    page: 1,
    limit: 1,
    sortBy: 'createdAt',
    sortOrder: 'desc',
    search: '',
    tags: [],
    tagOperation: 'OR',
    brand: 'all',
    collection: ''
  }

  weightError: string | null = null

  widthError: string | null = null

  lengthError: string | null = null

  heightError: string | null = null

  noPicture = NoPicture

  get isAnyDimensionFilled (): boolean {
    const d = this.product?.dimension || {}
    return this.isFilled(d.widthCm)
          || this.isFilled(d.lengthCm)
          || this.isFilled(d.heightCm)
  }

  get backgroundStyle (): { backgroundImage: string } {
    const image = this.product.photoUrls && this.product.photoUrls.length
        ? this.$convertImgix(this.product.photoUrls[0])
        : this.noPicture

    return {
      backgroundImage: `url(${image})`
    }
  }

  @Watch('product', { deep: true })
  onEditInfoChange (newVal: any, oldVal: any): void {
    if (oldVal !== null) {
      this.validate()
    }
  }

  isFilled = (v?: string | number | null | undefined): boolean => (v) !== null
    && v !== undefined
    && v !== ''
    && !Number.isNaN(v)

  async getSkuInfo (): Promise<void> {
    this.getting = true
    try {
      const { data } = await ProductService.getSkuInfo(this.$route.params.skuId)
      if (data?.length) {
        const skuInfo = data[0]
        this.product = {
          name: skuInfo.productDetail.name,
          model: skuInfo.productDetail.model,
          skuCode: skuInfo.code,
          skuId: skuInfo.id,
          productId: skuInfo.productDetail.id,
          weightGram: skuInfo.weightGram ?? null,
          dimension: skuInfo.dimension ?? {
            widthCm: null,
            lengthCm: null,
            heightCm: null
          },
          color: skuInfo.productDetail.colors[0],
          size: skuInfo.size,
          photoUrls: skuInfo.productDetail.photoUrls
        }
        if (!this.product?.weightGram) {
          this.$nextTick(() => {
            const el = (this.$refs.weightInput as Vue).$el.querySelector('input') as HTMLInputElement | null
            if (el) {
              el.focus()
            }
          })
        }
      }
    } catch (error) {
      console.error('fetchProducts', error)
    } finally {
      this.getting = false
    }
  }

  validate (): boolean {
    this.weightError = null
    this.widthError = null
    this.lengthError = null
    this.heightError = null

    const weight = this.product?.weightGram
    const { widthCm, lengthCm, heightCm } = this.product?.dimension || {}
    const hasWeight = this.isFilled(weight)

    const weightStr = String(weight ?? '').trim()

    if (this.isAnyDimensionFilled && !hasWeight) {
      this.weightError = null
    } else if (!hasWeight) {
      this.weightError = 'กรุณาระบุ'
    } else if (weightStr.includes('-') || !/^\d+$/.test(weightStr) || Number(weightStr) <= 0) {
      this.weightError = 'ต้องเป็นจำนวนเต็มบวกและไม่มีทศนิยม'
    }

    const validateDimension = (value: any): string | null => {
      const s = String(value ?? '').trim()

      // ถ้ากรอกน้ำหนักแล้ว และช่องนี้ว่าง -> อนุญาต (Optional)
      if (hasWeight && !this.isAnyDimensionFilled && !this.isFilled(value)) {
        return null
      }
      const additionalCondition = s.includes('-') || (!/^\d+(\.\d+)?$/.test(s)) || (s.includes('.') && !/^\d+\.\d{1}$/.test(s)) || Number(s) < 0
      if (!this.isFilled(value)) {
        return 'กรุณาระบุ'
      }
      if (additionalCondition) {
        return 'ค่าต้องมากกว่าหรือเท่ากับ 0 ทศนิยมไม่เกิน 1 ตำแหน่ง'
      }
      return null
    }

    if (!hasWeight || this.isAnyDimensionFilled) {
      this.widthError = validateDimension(widthCm)
      this.lengthError = validateDimension(lengthCm)
      this.heightError = validateDimension(heightCm)
    }

    return !this.weightError && !this.widthError && !this.lengthError && !this.heightError
  }

  async updateWeightAndDimension (): Promise<any> {
    if (!this.validate()) return

    this.saving = true
    try {
      this.$buefy.dialog.confirm({
        message: 'ต้องการบันทึกข้อมูลหรือไม่',
        canCancel: true,
        confirmText: 'บันทึก',
        cancelText: 'ยกเลิก',
        onConfirm: async () => {
          await ProductService.updateWeightAndDimension({
            skuId: this.product?.skuId,
            dimension: {
              widthCm: this.isFilled(this.product.dimension.widthCm) ? Number(this.product.dimension.widthCm) : null,
              lengthCm: this.isFilled(this.product.dimension.lengthCm) ? Number(this.product.dimension.lengthCm) : null,
              heightCm: this.isFilled(this.product.dimension.heightCm) ? Number(this.product.dimension.heightCm) : null
            },
            weightGram: this.isFilled(this.product.weightGram) ? Number(this.product.weightGram) : null
          })
          this.$buefy.toast.open({ message: 'การอัพเดตสำเร็จ', type: 'is-success', duration: 1000 })
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        }
      })
    } catch (error) {
      this.$buefy.toast.open({ message: 'การอัพเดตผิดพลาด', type: 'is-danger', duration: 2000 })
    } finally {
      this.saving = false
    }
  }

  mounted (): void {
    this.getSkuInfo()
  }
}
